import React, { Component } from "react";
import Variations from "../components/Variations";
import axios from "axios";
import * as urls from "../common/urls";

class ProductVariations extends Component {
  state = { variations: this.props.variations };

    componentDidUpdate(prevProps) {
        if (prevProps.variations !== this.props.variations) {
            this.setState({
                variations: this.props.variations
            });
        }
  }

  onVariationChanged = event => {
    let allVariationSelected = true;
    let selectedVariationsIds = [];
    for (let index = 0; index < this.props.variables.length; index++) {
      const elem = this[`variable${index}`];
      selectedVariationsIds.push(elem.value);
      if (elem.value === "-1") {
        allVariationSelected = false;
      }
    }
    const allVariationIds = selectedVariationsIds.join(",");

    if (allVariationSelected) {
      this.props.onAllVariationSelected(allVariationIds);
    } else {
      this.props.onAllVariationSelected(null);
      const url = `${urls.VARIATIONS_URL}${this.props.productId }/${allVariationIds}`;
      axios.get(url).then(res => {
        this.setState({
          variations: res.data.result
        });
      });
    }
  };

  render() {
    const { variables } = this.props;
    if (!variables) return <div />;

    const variablesList = variables.map((variable, i) => (
      <div className="col-sm-4" key={variable.id}>
        <div className="form-group">
          <label htmlFor={variable.name}>{variable.name}</label>
          <select
            className="form-control"
            onChange={this.onVariationChanged}
            ref={select => (this[`variable${i}`] = select)}
          >
            <Variations
              variations={this.state.variations}
              variableId={variable.id}
            />
          </select>
        </div>
      </div>
    ));

    return <div className="row margin-top-1x">{variablesList}</div>;
  }
}

export default ProductVariations;
